// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import AdminReturnRequest from "../../components/dashboard/AdminReturnRequest";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <AdminReturnRequest />
    </DashboardLayout>
  );
}
